import { useState } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GetCurrentDate } from "@services/Utilities";
import { error_message } from "@constants/Errors";
import { KAKELY_PATHS } from "@constants/NavigationPaths";
import { postTenantDepartmentArray } from "@services/API/Requests/TenantDepartmentRequests";

export const UseDepartmentGroupCsvUpload = () => {
  const navigate: NavigateFunction = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const currentDate = GetCurrentDate();

  const noCsvImportError = () => toast.error(error_message.csv.no_data);
  const uploadCsvDataToast = (message) => toast.success(message);
  const failCsvDataToast = (error) => toast.error(`${error}`);
  const [csvData, setCsvData] = useState<[]>([]);
  const [failedDepartments, setFailedDepartments] = useState<[]>();

  const handleCsvUpload = async () => {
    if (csvData.length === 0) {
      noCsvImportError();
      return;
    }

    const departmentDataArray = csvData.map((departmentInfo) => {
      const department = {
        id: departmentInfo.id,
        name: departmentInfo.name,
        name_kana: departmentInfo.name_kana,
        parent: departmentInfo.parent,
        display_order: departmentInfo.display_order,
        department_level: departmentInfo.department_level || 0,
        description: departmentInfo.description || "",
        delete: departmentInfo.delete,
        row: csvData.indexOf(departmentInfo) + 2,
      };

      return department;
    });

    const postDepartmentInformation = async (departmentDataArray) => {
      let response;
      try {
        response = await postTenantDepartmentArray(
          departmentDataArray,
          setLoading,
          setError,
        );
        if (response?.responseMessage.status === 200) {
          uploadCsvDataToast(
            response.failed_departments?.length
              ? `${response?.created_departments.length}件の部署情報を正常に更新しました。${response.failed_departments.length}件の部署情報の更新に失敗しました。`
              : `${response?.created_departments.length}件の部署情報を正常に更新しました。`,
          );
          return;
        } else {
          console.log(
            "Unexpected response status:",
            response?.responseMessage?.status,
          );
          failCsvDataToast(
            response.created_departments?.length
              ? `${response?.created_departments.length}件の部署情報を正常に更新しました。${response.failed_departments.length}件の部署情報の更新に失敗しました。`
              : `${response.failed_departments.length}件の部署情報の更新に失敗しました。`,
          );
          setFailedDepartments(response?.failed_departments);
        }
      } catch (error) {
        console.log("Caught error in postDepartmentInformation:", error);
        if (departmentDataArray.length == 1 && response?.failed_departments) {
          failCsvDataToast(
            response?.failed_departments?.length +
              "件の部署情報の更新に失敗しました。",
          );
          return;
        }
      }
    };
    await postDepartmentInformation(departmentDataArray);
  };

  const onCancel = () => {
    navigate(KAKELY_PATHS.allDepartmentSettings);
  };

  return {
    loading,
    csvData,
    failedDepartments,
    currentDate,
    handleCsvUpload,
    onCancel,
    setCsvData,
  };
};
